import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './testimonial.css'

import COLORS from '../../../themes/Colors'
import Slide from '../../common/Slide'
import ButtonNav from '../../common/ButtonNav'

import {
  Wrapper,
  BtnNext,
  BtnPrev,
  MainTitle,
  QuoteLeft,
  QuoteRight,
  WrapperTitle
} from './TestimonialsResponsive'

const Testimonials = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    dotsClass: 'custom-dots',
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <ButtonNav type='next' responsive={BtnNext} />,
    prevArrow: <ButtonNav type='prev' responsive={BtnPrev} />
  }

  return (
    <Wrapper
      bgColor={COLORS.bgTestimonials}
    >
      <WrapperTitle>
        <QuoteLeft bgColor='transparent'/>
        <MainTitle
          type='large'
          title='Testimonials'
        />
      </WrapperTitle>
      <Slider {...settings}>
        {
          data.map((item, index) => {
            return (
              <Slide
                key={index}
                description={item.node.text.text}
                author={item.node.client + ' - ' + item.node.role}
              />
            )
          })
        }
      </Slider>
      <QuoteRight bgColor='transparent'/>
    </Wrapper>
  )
}

Testimonials.PropTypes = {
  data: PropTypes.object.isRequired
}

export default Testimonials



// WEBPACK FOOTER //
// ./src/components/sections/testimonial/Testimonials.js